/* Custom Orders form: validation, product type preselect, endpoint submit with files */
(function () {
  var MB = 1024 * 1024;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setError(field, msg) {
    var errId = field.getAttribute('aria-describedby');
    var err = null;
    if (errId) {
      errId.split(' ').some(function (id) {
        var el = document.getElementById(id);
        if (el && el.classList.contains('co-field__error')) { err = el; return true; }
        return false;
      });
    }
    if (msg) field.setAttribute('aria-invalid', 'true');
    else field.removeAttribute('aria-invalid');
    if (err) err.textContent = msg || '';
  }

  function checkFiles(form, input) {
    if (!input || !input.files.length) return '';
    var maxFiles = +form.dataset.maxFiles || 5;
    var maxMb = +form.dataset.maxMb || 10;
    var maxTotal = +form.dataset.maxTotalMb || 25;
    var allowed = (input.getAttribute('accept') || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var total = 0;
    if (input.files.length > maxFiles) return 'You can attach up to ' + maxFiles + ' files.';
    for (var i = 0; i < input.files.length; i++) {
      var f = input.files[i];
      var ext = '.' + f.name.split('.').pop().toLowerCase();
      if (allowed.length && allowed.indexOf(ext) === -1) return '"' + f.name + '" has an unsupported file type.';
      if (f.size > maxMb * MB) return '"' + f.name + '" is larger than ' + maxMb + ' MB.';
      total += f.size;
    }
    if (total > maxTotal * MB) return 'Total size of files must not exceed ' + maxTotal + ' MB.';
    return '';
  }

  function validate(form) {
    var first = null;
    form.querySelectorAll('[required]').forEach(function (field) {
      var msg = '';
      var value = field.type === 'checkbox' ? field.checked : field.value.trim();
      if (!value) msg = field.type === 'checkbox' ? 'Please accept to continue.' : 'This field is required.';
      else if (field.type === 'email' && !EMAIL_RE.test(field.value.trim())) msg = 'Please enter a valid email address.';
      else if (field.minLength > 0 && field.value.trim().length < field.minLength) msg = 'Please add a few more details.';
      setError(field, msg);
      if (msg && !first) first = field;
    });
    var files = form.querySelector('input[type="file"]');
    if (files) {
      var fileMsg = checkFiles(form, files);
      setError(files, fileMsg);
      if (fileMsg && !first) first = files;
    }
    if (first) first.focus();
    return !first;
  }

  function status(form, type, text) {
    var box = form.querySelector('.co-form__status');
    if (!box) return;
    box.className = 'co-form__status co-form__status--' + type;
    box.textContent = text;
  }

  function track(form) {
    var type = form.querySelector('[name="contact[Product Type]"]');
    var country = form.querySelector('[name="contact[Delivery Country]"]');
    var files = form.querySelector('input[type="file"]');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: form.dataset.event || 'custom_quote_submit',
      form_id: 'custom_orders',
      form_mode: 'endpoint',
      product_type: type ? type.value : '',
      delivery_country: country ? country.value : '',
      files_count: files ? files.files.length : 0
    });
  }

  function submitToEndpoint(form) {
    var btn = form.querySelector('[type="submit"]');
    btn.disabled = true;
    status(form, 'info', 'Sending...');
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.ok === false) throw new Error(data.error || 'HTTP ' + res.status);
        });
      })
      .then(function () {
        track(form);
        form.reset();
        form.querySelector('[name="ts"]').value = Date.now();
        status(form, 'success', form.dataset.success);
      })
      .catch(function () {
        status(form, 'error', form.dataset.error);
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  function init(form) {
    form.noValidate = true;
    var ts = form.querySelector('[name="ts"]');
    if (ts) ts.value = Date.now();

    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true') setError(e.target, '');
    });
    form.addEventListener('change', function (e) {
      if (e.target.type === 'file') setError(e.target, checkFiles(form, e.target));
    });
    form.addEventListener('submit', function (e) {
      if (!validate(form)) { e.preventDefault(); return; }
      if (form.classList.contains('co-form__form--endpoint')) {
        e.preventDefault();
        submitToEndpoint(form);
      }
    });

    var posted = form.querySelector('[data-co-posted]');
    if (posted) posted.focus();
  }

  document.querySelectorAll('.co-form__form').forEach(init);

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-co-type]');
    if (!link) return;
    var select = document.querySelector('.co-form__form [name="contact[Product Type]"]');
    if (!select) return;
    var value = link.getAttribute('data-co-type');
    if (select.tagName !== 'SELECT') { select.value = value; return; }
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) { select.selectedIndex = i; setError(select, ''); break; }
    }
  });
})();
